import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgChevronRightBreadcrumbIcon = (
  componentProps: IconProps,
  props = {},
) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#353C4A"
        fillRule="evenodd"
        d="m16.32 13.2 3.36 4.8-3.36 4.8H14.4l3.2-4.8-3.2-4.8z"
        clipRule="evenodd"
      />
    </svg>,
  );
};
export default SvgChevronRightBreadcrumbIcon;
